export const themes = {
  dark: {
    // Rich, deep backgrounds with subtle blue undertone
    bgPrimary: '#050508',
    bgCard: '#0c0c12',
    bgElevated: '#12121a',
    bgInput: '#16161f',
    bgSecondary: '#0a0a0f',
    bgGlass: 'rgba(12, 12, 18, 0.8)',
    
    // Warm, readable text
    textPrimary: '#f0f0f5',
    textSecondary: '#9898a8',
    textMuted: '#5c5c6e',
    
    // NO borders - use shadows and gradients instead
    border: 'none',
    
    // Premium teal/cyan primary
    primary: '#00d4aa',
    primaryHover: '#00eebb',
    primaryMuted: '#00d4aa30',
    primaryGlow: '0 0 30px rgba(0, 212, 170, 0.3)',
    
    // Status colors - rich and vibrant
    success: '#00e676',
    successMuted: 'rgba(0, 230, 118, 0.15)',
    successGlow: '0 0 20px rgba(0, 230, 118, 0.2)',
    
    warning: '#ffab00',
    warningMuted: 'rgba(255, 171, 0, 0.15)',
    warningGlow: '0 0 20px rgba(255, 171, 0, 0.2)',
    
    danger: '#ff5252',
    dangerMuted: 'rgba(255, 82, 82, 0.15)',
    dangerGlow: '0 0 20px rgba(255, 82, 82, 0.2)',
    
    info: '#40c4ff',
    infoMuted: 'rgba(64, 196, 255, 0.15)',
    infoGlow: '0 0 20px rgba(64, 196, 255, 0.2)',
    
    purple: '#b388ff',
    purpleMuted: 'rgba(179, 136, 255, 0.15)',
    
    pink: '#ff80ab',
    pinkMuted: 'rgba(255, 128, 171, 0.15)',
    
    // Card styling
    cardShadow: '0 4px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.03)',
    cardHover: '0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 212, 170, 0.1)',
    
    // Table
    tableRowHover: 'rgba(0, 212, 170, 0.06)',
    tableRowAlt: 'rgba(255, 255, 255, 0.015)',
    
    // Gradients
    gradientPrimary: 'linear-gradient(135deg, #00d4aa 0%, #00a388 100%)',
    gradientCard: 'linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0) 100%)',
    gradientGlow: 'radial-gradient(ellipse at top, rgba(0, 212, 170, 0.1) 0%, transparent 50%)',
  },
  
  light: {
    // Soft, warm backgrounds - NOT harsh white
    bgPrimary: '#f5f5f8',
    bgCard: '#ffffff',
    bgElevated: '#f0f0f4',
    bgInput: '#ffffff',
    bgSecondary: '#fafafc',
    bgGlass: 'rgba(255, 255, 255, 0.9)',
    
    // Dark, readable text
    textPrimary: '#1a1a2e',
    textSecondary: '#4a4a5e',
    textMuted: '#8888a0',
    
    border: 'none',
    
    // Deeper teal for light mode
    primary: '#00a388',
    primaryHover: '#008872',
    primaryMuted: 'rgba(0, 163, 136, 0.12)',
    primaryGlow: '0 0 30px rgba(0, 163, 136, 0.15)',
    
    success: '#00c853',
    successMuted: 'rgba(0, 200, 83, 0.12)',
    successGlow: '0 0 20px rgba(0, 200, 83, 0.1)',
    
    warning: '#ff8f00',
    warningMuted: 'rgba(255, 143, 0, 0.12)',
    warningGlow: '0 0 20px rgba(255, 143, 0, 0.1)',
    
    danger: '#d32f2f',
    dangerMuted: 'rgba(211, 47, 47, 0.12)',
    dangerGlow: '0 0 20px rgba(211, 47, 47, 0.1)',
    
    info: '#0091ea',
    infoMuted: 'rgba(0, 145, 234, 0.12)',
    infoGlow: '0 0 20px rgba(0, 145, 234, 0.1)',
    
    purple: '#7c4dff',
    purpleMuted: 'rgba(124, 77, 255, 0.12)',
    
    pink: '#f50057',
    pinkMuted: 'rgba(245, 0, 87, 0.12)',
    
    cardShadow: '0 2px 12px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.03)',
    cardHover: '0 8px 24px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 163, 136, 0.1)',
    
    tableRowHover: 'rgba(0, 163, 136, 0.06)',
    tableRowAlt: 'rgba(0, 0, 0, 0.015)',
    
    gradientPrimary: 'linear-gradient(135deg, #00a388 0%, #007a66 100%)',
    gradientCard: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(250,250,252,1) 100%)',
    gradientGlow: 'radial-gradient(ellipse at top, rgba(0, 163, 136, 0.05) 0%, transparent 50%)',
  },
};

export const getTheme = (themeName) => themes[themeName] || themes.dark;